import { render, staticRenderFns } from "./go-back-button.vue?vue&type=template&id=2b711ba6&scoped=true&"
import script from "./go-back-button.vue?vue&type=script&lang=js&"
export * from "./go-back-button.vue?vue&type=script&lang=js&"
import style0 from "./go-back-button.vue?vue&type=style&index=0&id=2b711ba6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b711ba6",
  null
  
)

export default component.exports